export const SEGMENTATIONS_USERS_QUERY_MODEL_ID = "4689963d-d39d-473c-95ec-e9e8562c97a4";
export const SEGMENTATIONS_DELIVERY_CAMPAINGS_DELIVERIES_QUERY_MODEL_ID = "a98b79fd-3f5e-44dd-86b0-1db44e5b8a37";